/*
  Prev date and next day of the date range of holidays
  To block 01-01-2020, use range 31-12-2020 and 02-01-2021
  If there are days in between, again follow the same logic: day before and day after the range.
  Note: Specific for Dropdown Year Month Day datepicker.
*/

import { THAI_COUNTRY_ID } from '.';
import axios from 'axios';
import { API_URL } from './config';
import { toThaiDateTimeBase } from '../utils/helper';

interface HolidayRecord {
  applicable_from: string;
  applicable_till: string;
}

export const THAI_HOLIDAYS = async (params?: Record<string, unknown>): Promise<[string, string][]> => {
  const holidays: [string, string][] = [],
    currentYear = new Date().getFullYear();
  if (!params) {
    params = {
      applicable_from__gte: `${currentYear}-01-01 00:00:00`,
      order_by: 'applicable_from',
    };
  }
  params = { ...params, country: THAI_COUNTRY_ID };
  // Inlined from the legacy client, which is down to its last consumer. One caller, one endpoint —
  // a module-local request is the convention now, not a method on a 358-entry object.
  const { data: response } = await axios.get<HolidayRecord[]>(`${API_URL}master-data/holidays`, { params });
  response.forEach((res) => {
    holidays.push([toThaiDateTimeBase(res.applicable_from), toThaiDateTimeBase(res.applicable_till)]);
  });
  return holidays;
};
